import { Tabs } from "antd"
import styles from "./index.module.css"
import { useState } from "react"
import CashPaymentForm from "./CashPaymentForm"
import CardPaymentForm from "./CardPaymentForm"
import PropTypes from "prop-types"
import CustomDrawer from "ui/Drawer"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import { Modal } from "ui/Modal"

const RecordPaymentModal = ({ onOpen, onClose, remainingBalance, bookingUUID, bookingId }) => {
  const [activeTab, setActiveTab] = useState("cash")
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)

  const tabItems = [
    {
      key: "cash",
      label: "Cash",
      children: <CashPaymentForm remainingBalance={remainingBalance} bookingUUID={bookingUUID} bookingId={bookingId} onClose={onClose} />
    },
    {
      key: "card",
      label: "Card",
      children: <CardPaymentForm onClose={onClose} bookingId={bookingId} bookingUUID={bookingUUID} remainingBalance={remainingBalance} />
    }
  ]

  const modalContent = <Tabs className={styles.recordPaymentTabs} activeKey={activeTab} onChange={setActiveTab} items={tabItems} centered />

  return isMobile ? (
    <CustomDrawer open={onOpen} setOpen={onClose} title="Record Payment">
      {modalContent}
    </CustomDrawer>
  ) : (
    <Modal centered title="Record Payment" open={onOpen} onCancel={onClose} width={800}>
      {modalContent}
    </Modal>
  )
}

RecordPaymentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  remainingBalance: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number
}

export default RecordPaymentModal
